import { createUseStyles } from 'react-jss'

export const style = {
  header: {
    padding: '10px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  controlGrid: {
    padding: '10px 0',
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    rowGap: '10px',
    '@media (max-width: 991px)': {
      gridTemplateColumns: 'repeat(2, 1fr)'
    },
    '@media (max-width: 479px)': {
      gridTemplateColumns: 'repeat(1, 1fr)'
    }
  },
  controlFlex: {
    extend: 'controlGrid',
    padding: '0',
    display: 'flex',
    flexWrap: 'wrap'
  },
  controlCol: {
    display: 'inline-grid',
    position: 'relative',
    minWidth: '210px',
    gridColumn: 'span 1',
    gridTemplateColumns: 'repeat(1, 1fr)'
  },
  controlColSpan2: {
    extend: 'controlCol',
    gridColumn: 'span 2'
  },
  control: {
    position: 'relative',
    margin: `0 20px`,
    paddingTop: '25px',
    '@media (min-width: 480px)': {
      '&:not(:first-child)': {
        marginLeft: 0
      }
    }
  },
  controlLabel: {
    composes: ['form-element-label', 'text-ellipsis'],
    position: 'absolute',
    display: 'block',
    top: 0,
    width: '100%'
  },
  displayCol: {
    extend: 'controlCol',
    minWidth: 'auto'
  },
  slider: {
    extend: 'control',
    padding: '0 20px'
  },
  thresholdControl: {
    extend: 'control',
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    '& > $control': {
      margin: '0 20px 0 0',
      paddingTop: 0
    },
    '& > $slider': {
      margin: 0,
      paddingTop: 0
    },
    '@media (max-width: 479px)': {
      gridTemplateColumns: 'repeat(1, 1fr)',
      '& > $control': {
        margin: 0
      }
    }
  },
  displayFilter: {
    composes: ['form-element-label', 'text-ellipsis'],
    display: 'flex',
    margin: '0 20px'
  },
  displayLabel: {
    composes: 'text-ellipsis',
    display: 'inline-block'
  },
  displayValue: {
    display: 'inline-block',
    marginLeft: '5px',
    fontSize: '14px',
    fontWeight: 'bold',
    textTransform: 'capitalize'
  },
  reset: {
    margin: '0 20px',
    padding: 0,
    height: 'auto'
  }
}

export const useStyles = createUseStyles(style)
